module.exports = __webpack_public_path__ + "img/ios-bus.f1624a25.svg";